import { Button, Grid, Paper } from '@material-ui/core'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createAddress } from '../../../actions/addressActions'
import { updateUserInfo } from '../../../actions/userActions'
import { ADDRESS_CREATE_RESET } from '../../../constants/addressConstants'
import { USER_UPDATE_INFO_RESET } from '../../../constants/userConstants'
import statesList from '../../../data/states'
import { useInput } from '../../../hooks/useInput'
import AutoCompleteSelect from '../../Form/AutoCompleteSelect'
import CheckboxInput from '../../Form/CheckboxInput'
import FormContainer from '../../Form/FormContainer'
import TextInput from '../../Form/TextInput'
import Loader from '../../Loader/Loader'
import Message from '../../Message/Message'

const SignUpComplete = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    value: companyName,
    bind: bindCompanyName,
    error: companyNameError,
    setError: setCompanyNameError,
  } = useInput('')
  const {
    value: streetAddress,
    bind: bindStreetAddress,
    setError: setStreetAddressError,
    error: streetAddressError,
  } = useInput('')
  const { value: aptSuiteOther, bind: bindAptSuiteOther } = useInput('')
  const {
    value: zipCode,
    bind: bindZipCode,
    setError: setZipCodeError,
    error: zipCodeError,
  } = useInput('')
  const {
    value: city,
    bind: bindCity,
    setError: setCityError,
    error: cityError,
  } = useInput('')
  const {
    value: state,
    setValue: setState,
    setError: setStateError,
    error: stateError,
  } = useInput('')
  const { value: isDefaultShipping, setValue: setIsDefaultShipping } =
    useInput(true)
  const {
    value: shippingStreetAddress,
    bind: bindShippingStreetAddress,
    setError: setShippingStreetAddressError,
    error: shippingStreetAddressError,
  } = useInput('')
  const { value: shippingAptSuiteOther, bind: bindShippingAptSuiteOther } =
    useInput('')
  const {
    value: shippingZipCode,
    bind: bindShippingZipCode,
    setError: setShippingZipCodeError,
    error: shippingZipCodeError,
  } = useInput('')
  const {
    value: shippingCity,
    bind: bindShippingCity,
    setError: setShippingCityError,
    error: shippingCityError,
  } = useInput('')
  const {
    value: shippingState,
    setValue: setShippingState,
    setError: setShippingStateError,
    error: shippingStateError,
  } = useInput('')

  const addressCreate = useSelector((state) => state.addressCreate)
  const {
    loading: addressCreateLoading,
    error: addressCreateError,
    success,
  } = addressCreate

  const userUpdateInfo = useSelector((state) => state.userUpdateInfo)
  const {
    loading: userInfoUpdateLoading,
    error: userInfoUpdateError,
    success: updateUserInfoSuccess,
  } = userUpdateInfo

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (!userInfo) {
      history.push('/login')
    }

    if (success && updateUserInfoSuccess) {
      dispatch({ type: ADDRESS_CREATE_RESET })
      dispatch({ type: USER_UPDATE_INFO_RESET })

      history.push('/createaquote')
    }
  }, [dispatch, success, updateUserInfoSuccess, history, userInfo])

  const formIsValid = () => {
    let ready = true

    if (companyName === '') {
      ready = false
      setCompanyNameError('Please enter a company name.')
    } else {
      setCompanyNameError('')
    }

    if (streetAddress === '') {
      ready = false
      setStreetAddressError('Please enter a street address.')
    } else {
      setStreetAddressError('')
    }

    if (zipCode === '') {
      ready = false
      setZipCodeError('Please enter a zip code.')
    } else {
      setZipCodeError('')
    }

    if (state === '') {
      ready = false
      setStateError('Please select a state.')
    } else {
      setStateError('')
    }

    if (city === '') {
      ready = false
      setCityError('Please enter a city.')
    } else {
      setCityError('')
    }

    if (!isDefaultShipping) {
      if (shippingStreetAddress === '') {
        ready = false
        setShippingStreetAddressError('Please enter a street address.')
      } else {
        setShippingStreetAddressError('')
      }

      if (shippingZipCode === '') {
        ready = false
        setShippingZipCodeError('Please enter a zip code.')
      } else {
        setShippingZipCodeError('')
      }

      if (shippingState === '') {
        ready = false
        setShippingStateError('Please select a state.')
      } else {
        setShippingStateError('')
      }

      if (shippingCity === '') {
        ready = false
        setShippingCityError('Please enter a city.')
      } else {
        setShippingCityError('')
      }
    }

    return ready
  }

  const submitHandler = () => {
    if (formIsValid()) {
      const company = {
        companyName,
        streetAddress,
        aptSuiteOther,
        zipCode,
        state,
        city,
      }

      const user = { company }

      dispatch(updateUserInfo(user))

      if (isDefaultShipping) {
        let address = company
        address.isDefaultShipping = true
        address.isDefaultReturn = true
        address.user = userInfo._id

        dispatch(createAddress(address))
      } else {
        let address = {
          companyName,
          streetAddress: shippingStreetAddress,
          aptSuiteOther: shippingAptSuiteOther,
          zipCode: shippingZipCode,
          state: shippingState,
          city: shippingCity,
          isDefaultShipping: true,
          isDefaultReturn: true,
          user: userInfo._id,
        }

        dispatch(createAddress(address))
      }
    }
  }

  return (
    <div
      style={{ background: 'white', minHeight: 'calc(100vh - 152px)' }}
      className="sign-up-complete"
    >
      <FormContainer>
        <Paper
          elevation={3}
          className=" p-r-32 p-l-32 p-b-32 p-t-32"
          style={{ minHeight: 666 }}
        >
          {addressCreateLoading || userInfoUpdateLoading ? (
            <Loader />
          ) : (
            <>
              <h2 className="m-b-30">Complete sign up</h2>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextInput
                    name="companyName"
                    label="Company name"
                    bindValue={bindCompanyName}
                    error={companyNameError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    name="streetAddress"
                    label="Street address"
                    bindValue={bindStreetAddress}
                    error={streetAddressError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    name="aptSuiteOther"
                    label="Apt/Suite/Other"
                    bindValue={bindAptSuiteOther}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    name="zipCode"
                    label="Zip Code"
                    bindValue={bindZipCode}
                    error={zipCodeError}
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextInput
                    name="city"
                    label="City"
                    bindValue={bindCity}
                    error={cityError}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoCompleteSelect
                    label="State"
                    name="state"
                    options={statesList}
                    value={state}
                    setValue={setState}
                    error={stateError}
                    minWidth={93}
                  />
                </Grid>

                <Grid item xs={12} className="p-b-0">
                  <CheckboxInput
                    value={isDefaultShipping}
                    setValue={setIsDefaultShipping}
                    label={
                      <div className="fs14 m-t-10 m-b-0">
                        Use as default shipping address
                      </div>
                    }
                  />
                </Grid>
              </Grid>

              {!isDefaultShipping && (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextInput
                      name="streetAddress"
                      label="Street Address"
                      bindValue={bindShippingStreetAddress}
                      error={shippingStreetAddressError}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextInput
                      name="aptSuiteOther"
                      label="Apt/Suite/Other"
                      bindValue={bindShippingAptSuiteOther}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextInput
                      name="zipCode"
                      label="Zip Code"
                      bindValue={bindShippingZipCode}
                      error={shippingZipCodeError}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <TextInput
                      name="city"
                      label="City"
                      bindValue={bindShippingCity}
                      error={shippingCityError}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <AutoCompleteSelect
                      label="State"
                      name="state"
                      options={statesList}
                      value={shippingState}
                      setValue={setShippingState}
                      error={shippingStateError}
                      minWidth={93}
                    />
                  </Grid>
                </Grid>
              )}
              <div className="flex flex-end m-t-40">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={submitHandler}
                >
                  Save
                </Button>
              </div>
            </>
          )}

          {addressCreateError && (
            <Message variant="error">{addressCreateError}</Message>
          )}
          {userInfoUpdateError && (
            <Message variant="error">{userInfoUpdateError}</Message>
          )}
        </Paper>
      </FormContainer>
    </div>
  )
}

export default SignUpComplete
